'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Grid from '../components/moods/Grid'
import Channels from '../base/channels'
import RegisterMail from '../components/RegisterMail'
import Lazyload from '../components/moods/Lazyload';
import {TweenLite, TimelineLite} from 'gsap';
import Splide from '@splidejs/splide'


let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--press'
        // Objects
        // Fns
        if(this.view.querySelector('.jsIsotope--view') != null) {
            this.grid = new Grid(view)
            this.grid.setup()
        }
        this.moodletter = new RegisterMail(this.view.querySelector('.jsRegister--footer'))
        this.events()
        this.slideshow()
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        if(typeof this.grid != 'undefined') {
            this.grid.destroy()
        }
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    events()
    {
        Env.framework.UI.listenTransitionUpdateBg(this.view)
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 100);
        Env.framework.UI.lazy()
    }

    slideshow()
    {
        // new Splide( '.splide' ).mount();
        const $slideshow = this.view.querySelector('.jsSlideshow--view')
        if($slideshow != null) {
            this.slideshow = new Splide($slideshow , {
                arrows: true,
                arrowPath:false,
                type: 'fade',
                autoplay: true,
                interval: 7000,
                rewind: true,
                pauseOnFocus:false,
                pauseOnHover:false,
                pagination:true,
                easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                speed: 1000
            }).mount();
        }

    }

    intro()
    {
        const tl = new TimelineLite()
        const $header = this.view.querySelector('.mood-index__header')
        const $focus = this.view.querySelector('.mood-index__focus')
        const $grid = this.view.querySelector('.mood-index__receptor')

        tl.add([
            TweenLite.fromTo($header , .8 , { opacity : 0 , y : 10 } , { opacity : 1 , y : 0 , ease : Power3.easeOut }),
        ])
        if($focus !== null) {
            if(Env.mobileCSS === false) {
                tl.add([
                    TweenLite.fromTo($focus , .8 , { opacity : 0 , y : 20 } , { opacity : 1 , y : 0 , ease : Power3.easeOut , delay : .1 })
                ],'-=.8')
            }
        } else {
            tl.add([
                TweenLite.fromTo($grid , .8 , { opacity : 0 , y : 20 } , { opacity : 1 , y : 0 , ease : Power3.easeOut , delay : .1 })
            ],'-=.8')
        }
    }
}

page = Barba.BaseView.extend({
    namespace: 'press',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;